// import {
//   riversideElementary,
//   oakMiddleSchool,
//   pineHighSchool,
//   sunsetPrep,
//   valleyMontessori,
//   techAcademy
// } from "../mockSchools";
// import { generateMockInteractions } from "./interactions";
// import { getTodayTask } from "./tasks";

export const originalLeads = [
  {
    id: '12350',
    name: 'Maria Rodriguez',
    email: 'maria@example.com',
    phone: '(555) 678-9012',
    status: 'new',
    assignedTo: 'John Smith',
    dateAdded: '2024-02-16',
    grade: '8',
    lastUpdatedBy: 'David Park',
    lastUpdatedAt: '2024-02-16',
    student: 'Carlos Rodriguez',
    tasks: [],
    schools: [{ name: 'Test 1' }, { name: 'Test 2' }],
    interactions: [],
  },
  {
    id: '12351',
    name: 'James Wilson',
    email: 'james@example.com',
    phone: '(555) 789-0123',
    status: 'new',
    assignedTo: 'Unassigned',
    dateAdded: '2024-02-15',
    grade: '7',
    student: 'Emma Wilson',
    lastUpdatedBy: 'Emily Chen',
    lastUpdatedAt: '2024-02-16',
    tasks: [],
    schools: [{ name: 'Test 3' }],
    interactions: [],
  },
  {
    id: '12352',
    name: 'Sofia Garcia',
    email: 'sofia@example.com',
    phone: '(555) 890-1234',
    status: 'new',
    assignedTo: 'Unassigned',
    dateAdded: '2024-02-16',
    grade: '9',
    student: 'Diego Garcia',
    lastUpdatedBy: 'Mike Wilson',
    lastUpdatedAt: '2024-02-16',
    tasks: [],
    schools: [],
    interactions: [],
  },
  {
    id: '12353',
    name: 'Lucas Kim',
    email: 'lucas@example.com',
    phone: '(555) 901-2345',
    status: 'new',
    assignedTo: 'Unassigned',
    dateAdded: '2024-02-15',
    grade: '10',
    student: 'Mia Kim',
    lastUpdatedBy: 'Sarah Johnson',
    lastUpdatedAt: '2024-02-16',
    tasks: [],
    schools: [],
    interactions: [],
  },
  {
    id: '12354',
    name: 'Emma Thompson',
    email: 'emma@example.com',
    phone: '(555) 012-3456',
    status: 'new',
    assignedTo: 'Unassigned',
    dateAdded: '2024-02-16',
    grade: '12',
    student: 'Oliver Thompson',
    lastUpdatedBy: 'John Smith',
    lastUpdatedAt: '2024-02-16',
    tasks: [],
    schools: [],
    interactions: [],
  },
  {
    id: '12355',
    name: 'Alex Chen',
    email: 'alex@example.com',
    phone: '(555) 123-4567',
    status: 'attempting',
    assignedTo: 'Unassigned',
    dateAdded: '2024-02-14',
    grade: '6',
    student: 'Sophia Chen',
    lastUpdatedBy: 'Sarah Johnson',
    lastUpdatedAt: '2024-02-16',
    tasks: [],
    schools: [],
    interactions: [],
  },
  {
    id: '12356',
    name: 'Isabella Martinez',
    email: 'isabella@example.com',
    phone: '(555) 234-5678',
    status: 'attempting',
    assignedTo: 'Unassigned',
    dateAdded: '2024-02-13',
    grade: '11',
    student: 'Lucas Martinez',
    lastUpdatedBy: 'Mike Wilson',
    lastUpdatedAt: '2024-02-16',
    tasks: [],
    schools: [],
    interactions: [],
  },
  {
    id: '12357',
    name: 'William Taylor',
    email: 'william@example.com',
    phone: '(555) 345-6789',
    status: 'working',
    assignedTo: 'Unassigned',
    dateAdded: '2024-02-12',
    grade: '9',
    student: 'Ava Taylor',
    lastUpdatedBy: 'Emily Chen',
    lastUpdatedAt: '2024-02-16',
    tasks: [],
    schools: [],
    interactions: [],
  },
  {
    id: '12358',
    name: 'Olivia Brown',
    email: 'olivia@example.com',
    phone: '(555) 456-7890',
    status: 'working',
    assignedTo: 'Unassigned',
    dateAdded: '2024-02-11',
    grade: '7',
    student: 'Ethan Brown',
    lastUpdatedBy: 'David Park',
    lastUpdatedAt: '2024-02-16',
    tasks: [],
    schools: [],
    interactions: [],
  },
  {
    id: '12359',
    name: 'Ethan Johnson',
    email: 'ethan@example.com',
    phone: '(555) 567-8901',
    status: 'application-sent',
    assignedTo: 'Unassigned',
    dateAdded: '2024-02-10',
    grade: '8',
    student: 'Lily Johnson',
    lastUpdatedBy: 'Sarah Johnson',
    lastUpdatedAt: '2024-02-16',
    tasks: [],
    schools: [],
    interactions: [],
  },
  {
    id: '12360',
    name: 'Sophia Lee',
    email: 'sophia@example.com',
    phone: '(555) 678-9012',
    status: 'archived',
    assignedTo: 'Unassigned',
    dateAdded: '2024-02-09',
    grade: '10',
    student: 'Noah Lee',
    lastUpdatedBy: 'Mike Wilson',
    lastUpdatedAt: '2024-02-16',
    tasks: [],
    schools: [],
    interactions: [],
  },
];

export const assignedLeads = [
  {
    id: '12357',
    name: 'William Taylor',
    email: 'william@example.com',
    phone: '(555) 345-6789',
    status: 'working',
    dateAdded: '2024-02-12',
    grade: '9',
    student: 'Ava Taylor',
    lastUpdatedBy: 'Emily Chen',
    lastUpdatedAt: '2024-02-16',
    tasks: [],
    school: 'Montessori School ACA',
    school_id: '1234',
    interactions: [],
  },
];
